<div class="notification-badge__container">
  <div class="notification-badge flex justify-center align-center">{{ notificationNumber }}</div>
</div>
